import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";

import Frame from "frame";

import "assets/styles/index.css";

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter basename={process.env.REACT_APP_ROUTER_BASENAME}>
      <Frame />
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById("root"),
);
